<template>
  <div id="nav-contact">
    <div class="text-center">
      <h2 class="title line center">Contact</h2>
    </div>

    <b-row cols="1" cols-sm="1" cols-md="2" cols-lg="2">
      <b-col>
        <div class="text-form">
          <p class="heading center">Brașov Trail Adventures</p>
          <p>
            Dacă vrei sa afli mai multe informații despre produsele BTA și cum
            le poți achiziționa, te rugăm sa ne trimiți un mesaj prin formularul
            de contact.
          </p>

          <div>
            <span>
              <b-icon
                icon="chat"
                style="
                  color: rgb(0, 123, 255);
                  width: 40px;
                  height: 40px;
                  padding: 5px;
                  margin-right: 15px;
                "
              ></b-icon>
              Telefon: 0799 976 596
            </span>
          </div>

          <div>
            <span>
              <b-icon
                icon="calendar"
                style="
                  color: rgb(0, 123, 255);
                  width: 40px;
                  height: 40px;
                  padding: 5px;
                  margin-right: 15px;
                "
              ></b-icon>
              Luni - Vineri: 09:00 - 17:00
            </span>
          </div>

          <div>
            <span>
              <b-icon
                icon="geo"
                style="
                  color: rgb(0, 123, 255);
                  width: 40px;
                  height: 40px;
                  padding: 5px;
                  margin-right: 15px;
                "
              ></b-icon>
              Brașov, România
            </span>
          </div>
        </div>
      </b-col>

      <b-col>
        <div class="text-form">
          <b-form @submit="onSubmit" class="form-style">
            <b-form-group id="input-group-2" label="Nume:" label-for="input-2">
              <b-form-input
                id="input-2"
                v-model="form.name"
                required
                placeholder="Numele tău"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              id="input-group-1"
              label="Adresă e-mail:"
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                v-model="form.email"
                type="email"
                required
                placeholder="Adresa ta de e-mail"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-3" label="Mesaj:" label-for="input-3">
              <b-form-textarea
                id="textarea"
                v-model="form.message"
                placeholder="Mesajul tău"
                rows="3"
                max-rows="3"
                required
              ></b-form-textarea>
            </b-form-group>

            <!-- <input
              id="consent"
              type="checkbox"
              name="_I_agree"
              style="position: absolute;left: -400%;"
              tabindex="-1"
              autocomplete="off"
            /> -->

            <b-button
              type="submit"
              variant="outline-primary"
              :disabled="submitted"
              >Trimite mesaj</b-button
            >

            <div v-if="savingSuccessful" role="alert" class="styled-alert">
              <b-alert
                :show="dismissCountDown"
                dismissible
                @dismissed="dismissCountDown = 0"
                @dismiss-count-down="countDownChanged"
              >
                Mesaj trimis. Mulțumim!
              </b-alert>
            </div>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Botpoison from "@botpoison/browser";

export default {
  data() {
    return {
      form: {
        email: "",
        name: "",
        message: "",
      },
      submitted: false,
      savingSuccessful: false,
      dismissSecs: 5,
      dismissCountDown: 0,
    };
  },

  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },

    resetForm() {
      this.form.email = "";
      this.form.name = "";
      this.form.message = "";
    },

    async onSubmit(evt) {
      evt.preventDefault();
      let vm = this;

      const botpoison = new Botpoison({
        publicKey: 'pk_16bb5c57-aa49-4011-bfef-d8e495e15e80',
      });

      const {solution} = await botpoison.challenge();
      console.log("solution -->", solution)

      try {
        const response = await this.axios
          .post("https://submit-form.com/bbuuUPQI0i44GaFfSzqT-", {
            email: this.form.email,
            name: this.form.name,
            message: this.form.message,
            _botpoison: solution,
          })

          console.log(response);
          vm.savingSuccessful = true;
          vm.submitted = true;
          vm.showAlert();
          vm.resetForm();
      } catch (error) {
        vm.output = error;
      }
    },
  },
};
</script>

<style>
.text-form span {
  display: flex;
  align-items: center;
  margin-top: 10px;
  color: #6e6b66;
}

.styled-alert {
  margin-top: 10px;
}

button .btn .styled-button .btn-secondary {
  height: 40px;
  text-transform: none;
  font-weight: 400;
  background-color: transparent;
  border: 1px solid #0072bb;
  color: #0072bb;
  transition: all 0.4s ease;
  text-transform: uppercase;
  border-radius: 2px;
  padding-right: 30px;
  padding-left: 30px;
  text-align: center;
  font-size: 12px;
  letter-spacing: 1px;
  font-family: "Roboto", sans-serif;
  display: inline-block;
  overflow: hidden;
  outline: none;
}

.text-center {
  text-align: center;
  padding: 50px 0;
  color: #6e6b66;
}

.text-form {
  padding: 15px;
  text-align: left;
  color: #6e6b66;
}

h2 {
  margin-top: 45px;
  color: #2f2911;
  text-transform: uppercase;
  position: relative;
  letter-spacing: 0;
  font-size: 26px;
  line-height: 40px;
  font-weight: 300;
}

p .text-form {
  color: #6e6b66;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 16px;
  letter-spacing: 0.5px;
  font-weight: 300;
  text-align: justify;
}

h2.title.line {
  margin-top: 45px;
}

h2.title.line:after {
  position: absolute;
  content: "";
  display: block;
  margin: 0 auto;
  left: 0;
  right: 0;
  z-index: -1;
  height: 40px;
  width: 2px;
  background-color: #0072bb;
  top: -50px;
}
</style>
